import 'ol/ol.css';
import GeoJSON from 'ol/format/GeoJSON';
import Map from 'ol/Map';
//Vectors - to present vector layers
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import ImageLayer from 'ol/layer/Image.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import OSM from 'ol/source/OSM.js';
//---- before the View
import View from 'ol/View';
import {defaults as defaultControls} from 'ol/control.js';
import MousePosition from 'ol/control/MousePosition.js';
import {createStringXY} from 'ol/coordinate.js';
import {toStringXY} from 'ol/coordinate.js';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS.js';
import XYZSource from 'ol/source/XYZ';
import {fromLonLat} from 'ol/proj';
import {transformExtent} from 'ol/proj.js';
import sync from 'ol-hashed';
// draganddrop - for importing new features
import DragAndDrop from 'ol/interaction/DragAndDrop';
//Modify features imported
import {defaults as defaultInteractions, Modify, Select} from 'ol/interaction.js';
//import Modify from 'ol/interaction/Modify';
// Drawing import
import Draw from 'ol/interaction/Draw';
//Snaping
import Snap from 'ol/interaction/Snap';
//style - for shaping the vectors
import {Circle as CircleStyle,Fill, Stroke, Style, Text} from 'ol/style.js';
// Overlay import
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
//import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';
//https://geotiffjs.github.io/geotiff.js/
import {getArea, getLength} from 'ol/sphere.js';
import {unByKey} from 'ol/Observable.js';
import {LineString, Polygon} from 'ol/geom.js';
import Geolocation from 'ol/Geolocation';

//Added in V3
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';

//var helpTooltipElement;
// Variables
//Messages
var BrowseMessage = "Double click fo view info";
var EditMessage="Select and change";
var DeleteMessage ="Click to delete";
var Textmessage = '';
var DrawMessage = "Click to start";
var DrawMessageEnd = "Finished, Click to start drawing";
var OptionsMode = "Browsemode";
var Examplemode = "Notactive";
var Draw_type="Polygon";
var drawing_started=0;
var SelectedID = 0
var output=0;
var length=0;
var modifystart=1;
var originalfeature=null;
var hole;
var modifying=0;
var saved=0;
var deleted=0;
var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();
today = mm + '/' + dd + '/' + yyyy;



//console.log(document.getElementById('projection').value);

var uagent = navigator.userAgent.toLowerCase();
console.log(uagent);
var scrwidth = screen.width;
console.log(scrwidth);

if (scrwidth < 456){
document.getElementById("editw").style.visibility="hidden";
document.getElementById("editcad").style.visibility="hidden";
};

document.getElementById("editw").style.visibility="hidden";
document.getElementById("editcad").style.visibility="hidden";

var mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(4),
        projection: document.getElementById('projection').value,
        // comment the following two lines to have the mouse position
        // be placed within the map.
        className: 'custom-mouse-position',
        target: document.getElementById('mouse-position'),
        undefinedHTML: '&nbsp;'
      });

//style for shaping the vectors
 var style = new Style({
        fill: new Fill({
//          color: 'rgba(255, 255, 255, 0.6)'
          color: 'rgba(255, 255, 255, 0.1)'
        }),
        stroke: new Stroke({
          color: '#319FD3',
          width: 2
        }),
        text: new Text(
{
          font: '12px Calibri,sans-serif',
          overflow: true,
          fill: new Fill({
//            color: '#000'
              color: 'yellow'
             }),
	  backgroundFill: new Fill({
//            color: '#000'
              color: 'black'
             })
         }
),
image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })     
      });

//Transformations



function transform(extent) {
        return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
      };

var extents = {
        Albania: transform([19.3,39.7,21.09,42.7])
      };
        

const wmsextent = [19.3,39.7,21.09,42.7];

//Sources WMS






//OrtoCIR_LOT2:LOT2
//basemap:dem_hillshade
//qttb:perdorim2016end

var wmsSource = new TileWMS({
//url: 'https://prostor4.gov.si/ows2-m-pub/SI.GURS.ZPDZ/ows',
//projection:'CRS:84',
        url: 'https://geoportal.asig.gov.al/service/ows',
       projection:'EPSG:4326',
//url: 'https://geoportal.dgu.hr/services/inspire/orthophoto_2014-2016/wms',//Croatia
// cro      projection:'CRS:84',
        minZoom: 11,
//        params: {'LAYERS':"OI.OrthoImagery",'TILED': false, //Croatia
        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
//        params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 
//params: {'LAYERS':"basemap:dem_hillshade",'TILED': false, 
//params: {'LAYERS':"qttb:perdorim2016end",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
//params: {'LAYERS':"basemap:basemap-villages",'TILED': false, 
//params: {'LAYERS':"DOF050_D48",'TILED': false, 
'FORMAT':'image/png'},
        serverType: 'geoserver'
});
const ALBlayer = new TileLayer({
//   extent: extents.Albania,
   source: wmsSource
});

var wmsALBCIRSource = new TileWMS({
        url: 'https://geoportal.asig.gov.al/service/ows',
        projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
       params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 
//params: {'LAYERS':"basemap:dem_hillshade",'TILED': false, 
//params: {'LAYERS':"qttb:perdorim2016end",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
//params: {'LAYERS':"basemap:basemap-villages",'TILED': false, 
'FORMAT':'image/png'},
        serverType: 'geoserver'
});

//Added in V3
var wmtssource = new WMTS({
//        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
//            'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
        url: 'https://https://tiles.maps.eox.at/wmts/1.0.0/',
        layer: '0',
//        matrixSet: 'EPSG:3857',
        format: 'image/png',
//        projection: projection,
//        tileGrid: new WMTSTileGrid({
//          origin: getTopLeft(projectionExtent),
//          resolutions: resolutions,
//          matrixIds: matrixIds
//        }),
//        style: 'default',
//        wrapX: true
      });


//Added in V3
const wmtslayer = new TileLayer({
      source: wmtssource
});

var wmsALBDEMSource = new TileWMS({
        url: 'https://geoportal.asig.gov.al/service/ows',
        projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"orthophoto_2015:OrthoImagery_20cm",'TILED': false, 
//       params: {'LAYERS':"OrtoCIR_LOT2:LOT2",'TILED': false, 

// uselessparams: {'LAYERS':"Dtm_2015:Hillshade_2015_group",'TILED': false, 
//params: {'LAYERS':"basemap:relief",'TILED': false, 
params: {'LAYERS':"Dtm_2015:Dem_2015",'TILED': false, 
'FORMAT':'image/png', 'transparent':true},
        serverType: 'geoserver'
});


const ALBCIRlayer = new TileLayer({
   extent: extents.Albania,
   source: wmsALBCIRSource
});

const ALBDEMlayer = new TileLayer({
   extent: extents.Albania,
   source: wmsALBDEMSource
});

var wmsALBcadI = new ImageWMS({
url: 'https://geoportal.asig.gov.al/service/ows',    
              params: {'LAYERS':"parcela_kadastrale_qkd_042025"}, //woorkable albania
        serverType: 'geoserver'    
                 });

var wmsALBcad = new TileWMS({
url: 'https://geoportal.asig.gov.al/service/ows',
//url: "https://storitve.eprostor.gov.si/ows-ins-wms/cp/ows",
//url: "https://prostor4.gov.si/ows2-ins-m/ows",
// cro url: //'https://oss.uredjenazemlja.hr/OssWebServices/inspireService/wms?//token=bcd28508fda6c11a4f3c1af2eff047//8501a200b8a798afdf520f46a0d760e5cc',       
projection:'EPSG:4326',
        minZoom: 11,
//        params: {'LAYERS':"zrpp:parcelat",'TILED': false, 'FORMAT':'image/png', 'transperent':true},
//               params: {'LAYERS':"CP.CadastralParcel",'TILED': false, 'FORMAT':'image/png', //'transparent':true},//workable croatia
//               params: {'LAYERS':"CP.CadastralParcel",'TILED': false, 'FORMAT':'image/png', 
//'transparent':true}, //workable slovenia
              params: {'LAYERS':"p_kadastrale_ashk_042025",'TILED': false, 'FORMAT':'image/png', 'transparent':true}, //woorkable albania
        serverType: 'geoserver'    
                 });
const ALBcadlayer = new TileLayer({
//   extent: extents.Albania,
   source: wmsALBcad
});

const ALBcadlayerI = new ImageLayer({
//   extent: extents.Albania,
   source: wmsALBcadI
});


var GoogleSource =new XYZSource({
        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
      });



const googlemaps=new TileLayer({
//   extent: extents.Albania,
   source: GoogleSource
//new XYZSource({
//        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
//      })
});
const view=new View({
     projection: "EPSG:3857",
     center: [0, 0],
     zoom: 15
  })




const map=new Map({
  target: 'map-container',
  controls: defaultControls().extend([mousePositionControl]),
  layers: [googlemaps
//     new TileLayer({
//      source: new XYZSource({
//        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
//      })
//        })
//,
//ALBlayer,
//ALBcadlayer
  ],
  view: view
});

//map.addLayer(ALBlayer);
//map.addLayer(ALBDEMlayer);
//map.addLayer(ALBCIRlayer);
map.addLayer(ALBcadlayerI);

//Added in V3
//map.addLayer (wmtslayer);

var geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true
  },
  projection: view.getProjection()
});

var accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function() {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

var positionFeature = new Feature();
positionFeature.setStyle(new Style({
  image: new CircleStyle({
    radius: 6,
    fill: new Fill({
    color: 'red'
//      color: '#3399CC'
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 2
    })
  })
}));


sync(map);
// constant vector source - empty for import - adding new layer


//Open Layers
const googlestreet = new TileLayer({
  source: new XYZSource({
      url: 'https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}'    
        })
});
map.addLayer(googlestreet);

const osmlayer = new TileLayer({
  source: new OSM()
});
map.addLayer(osmlayer);
osmlayer.setVisible(document.getElementById("1").checked);

//GeoJSON Layers
//const countries = new VectorLayer({
//  source: new VectorSource({
//        format: new GeoJSON(),
//        url: './data/countries.json'
//        
//      }),
//});
//map.addLayer(countries);


//user layers
const source = new VectorSource();
const layer = new VectorLayer({
  source: source,
  style: function(feature) {
      console.log('Check you get the property', feature.getId());
     style.getText().setText(feature.getId());
     return style;
    }
});
map.addLayer(layer);


// - end adding new layer with drop down

var infocenter= map.getView().getCenter();
console.log (infocenter);
const infocoords = fromLonLat([0,30]);
console.log (infocoords);
//infocoords[0]=0;
//infocoords[1]=0;
map.getView().animate({center: infocoords, zoom: 2.3});
navigator.geolocation.getCurrentPosition(function(pos) {
  const coords = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
  map.getView().animate({center: coords, zoom: 12});
console.log (coords);
console.log (geolocation);
console.log (navigator);
});

//Map overlay: feature overlay
var featureOverlay = new VectorLayer({
        source: new VectorSource(),
        map: map,
        style: new Style({
          stroke: new Stroke({
            color: '#f00',
            width: 1
          }),
          fill: new Fill({
            color: 'rgba(255,0,0,0.1)'
          }),
        })
       });

//Highlight selected feature function
      var highlight;
      var displayFeatureInfo = function(pixel) {
        var feature = map.forEachFeatureAtPixel(pixel, function(feature) {     
          return feature;
        });   
        var info1 = document.getElementById('info1');
        var IDunderpixel=feature.getId();
        if (feature) {
          console.log(feature.getId());
          info1.innerHTML = feature.getId() + ': ' + feature.get('name');
         
             var targetpolygon=feature.getGeometry();
              output=getArea(targetpolygon);
              length=getLength(targetpolygon);
              console.log ("output:"+output+"length:"+length); 
                console.log ("Properties: "+feature.getProperties());      
        } else {
          info1.innerHTML = '&nbsp;';
        }
        if (feature !== highlight) {
          if (highlight) {
            featureOverlay.getSource().removeFeature(highlight);
          }
          if (feature) {
            featureOverlay.getSource().addFeature(feature);
                      }
          highlight = feature;
        }
      };

// Countries are shown only if zoom level < 7
//const initial_country_value=document.getElementById("2").checked;
//view.on('change:resolution', function(evt) {
//	var current_zoom=map.getView().getZoom();
//	console.log ('zoom:'+current_zoom);
//	if (current_zoom > 6) {
//	   document.getElementById("2").checked = false;
//	   document.getElementById("2").disabled=true;
//	   countries.setVisible(false);}
//	else{
//	   document.getElementById("2").checked = initial_country_value;
//	   document.getElementById("2").disabled=false;
//	   countries.setVisible(true);
//	};
        
//});


//overlay in pop-up container 
//
const overlay = new Overlay({
  element: document.getElementById('popup-container'),
  positioning: 'bottom-center',
  offset: [0, -40],
//  autoPan: true
});
//map.addOverlay(overlay);

//overlay in pop-up container 
//



// Tooltip overlay - diplaying help texts on cursor
// function createHelpTooltip() {
//        if (helpTooltipElement) {
//          helpTooltipElement.parentNode.removeChild(helpTooltipElement);
//        }
        const helpTooltipElement = document.createElement('div');
//        helpTooltipElement.className = 'tooltip hidden';
        const helpTooltip = new Overlay({
          element: helpTooltipElement,
          offset: [20, 0],
          positioning: 'center-left'
        });
        map.addOverlay(helpTooltip);
//      }



//Events
//If pointer moved-over feature,  highlite te feature geometry, get the highlight

     map.on('pointermove', function(evt) {
//    map.on('dblclick', function(evt) {
            
      if (evt.dragging) {
          return;
        };


        var pixel = map.getEventPixel(evt.originalEvent);
//        displayFeatureInfo(pixel, layer);

     if (drawing_started >0) {Textmessage = 'Click for next verticle or to finish'} //else {
//Textmessage = 'Click to Draw'};
   helpTooltipElement.innerHTML = Textmessage;
   helpTooltip.setPosition(evt.coordinate);
           
      });

// If double cliked - display features of highlited feature
	map.on('dblclick', function(e) {
//map.on('pointermove', function(e) {
  let markup = '';
  map.forEachFeatureAtPixel(e.pixel, function(feature) {
    markup += `${markup && '<hr>'}<table>`;
    const properties = feature.getProperties();
    const PolyID = feature.getId();
document.getElementById('PolyID').value = PolyID;
document.getElementById('PolyName').value=properties.name;
document.getElementById('PolyUse').value=properties.name;
document.getElementById('PolyArea').value=properties.Area;
document.getElementById('IDClient').value=properties.name;
document.getElementById('IDCreated').value=properties.name;
document.getElementById('PolyDate').value=properties.Length;
console.log ('properties:'+properties.name);
    for (const property in properties) {
      markup += `<tr><th>${property}</th><td>${properties[property]}</td></tr>`;
    }
    markup += '</table>';
  }, {hitTolerance: 1});
  if (markup) {
    document.getElementById('popup-content').innerHTML = markup;

    overlay.setPosition(e.coordinate);
  } else {
    overlay.setPosition();
  }
});




//End overlay features - select Tool-texts for diplaying



map.on('dblclick', function (evt) {
//map.on('click', function (evt) {
//Display mouse coords
var mouseCoords = [evt.originalEvent.offsetX, evt.originalEvent.offsetY];
var mousecoord=map.getCoordinateFromPixel(mouseCoords);
//document.getElementById('selected_locationX').value=mousecoord[0];
//document.getElementById('selected_locationY').value=mousecoord[1];
//document.getElementById('selected_projection').value="EPSG:3857";
console.log (mouseCoords);
var nogeom = source.getFeatures();
//.length;  
console.log ("ftrs"+nogeom.length);
var target1= map.getTarget();
//var IDs = target1.getId();
console.log ("target"+target1);
console.log ("Doubeclicked");
// display info on info on parcels WMS (info field)
//document.getElementById('info').innerHTML = '';
        var viewResolution = /** @type {number} */ (view.getResolution());
       var url = wmsALBcad.getGetFeatureInfoUrl(
//var url = wmsSource.getGetFeatureInfoUrl(
          evt.coordinate, viewResolution, 'EPSG:3857',
//{'INFO_FORMAT': 'text/javascript'}); not supported
//{'INFO_FORMAT': 'text/plain'});
//        {'INFO_FORMAT': 'text/html'});
         {'INFO_FORMAT': 'application/json'});
         console.log (url);
console.log ("resolution"+view.getMaxResolution());
//var url1 = wmsSource.getGetFeatureInfoUrl(
//var url1 = wmsALBCIRSource.getGetFeatureInfoUrl(
     var url1 = wmsALBDEMSource.getGetFeatureInfoUrl(
          evt.coordinate, viewResolution, 'EPSG:3857',
//{'INFO_FORMAT': 'text/javascript'}); not supported
//{'INFO_FORMAT': 'text/plain'});
//        {'INFO_FORMAT': 'text/html'});
         {'INFO_FORMAT': 'application/json'});
         console.log (url1);

        if (url) {
//          document.getElementById('info').innerHTML = '<iframe  src="' + url + '"></iframe>';

//document.getElementById("info1").innerHTML='<iframe id="iframe1" src="' + url1 + '"></iframe>';

//var x = document.getElementById("info1").src;
var data;
$.getJSON(url, function(data) {
console.log (data);
console.log (data.features[0].properties);
document.getElementById("Cadzone").value=data.features[0].properties.nrzk
document.getElementById("Cadparcel").value=data.features[0].properties.nrpas
document.getElementById("CadArea").value=data.features[0].properties.shape_area

},function(success){
console.log (success);}
); 

//dem data

$.getJSON(url1, function(data) {
console.log (data);
console.log (data.features[0].properties);
document.getElementById("CadElev").value=data.features[0].properties.GRAY_INDEX
},function(success){
console.log (success);}
); 

//cir data
//$.getJSON(url1, function(data) {
//console.log (data);
//console.log (data.features[0].properties)
//},function(success){
//console.log (success);}
//);

var x = document.getElementById("info1");
var y = document.getElementById("info");

console.log (x);
console.log (y);




        }


//    alert(iFrameBody.innerHTML);
 
//document.getElementById('id_iframe').contentWindow.document.write('content');
//https://stackoverflow.com/questions/926916/how-to-get-the-bodys-content-of-an-iframe-in-javascript


//selection of feature
var pixel = evt.pixel;
        var feature = map.forEachFeatureAtPixel(pixel, function(feature) {     
          return feature;
        }); 

console.log ("pixel:"+pixel);
if (feature){
console.log ("featureID"+feature.getId());
SelectedID = feature.getId();
console.log ("SelectedID"+SelectedID);
var geom=feature.getGeometry();
//var FeaturesArray = select.getFeatures().getArray();
console.log (FeaturesArray);
console.log (getArea(geom))};
//case browse mode - display information
//Show_data(evt);
//case create mode - start/end drawing
//case change mode - select and start/end editing - display info on 


});


//
var projectionSelect = document.getElementById('projection');
      projectionSelect.addEventListener('change', function(event) {
        mousePositionControl.setProjection(event.target.value);
      });

      var precisionInput = document.getElementById('precision');
      precisionInput.addEventListener('change', function(event) {
        var format = createStringXY(event.target.valueAsNumber);
        mousePositionControl.setCoordinateFormat(format);
      });

//Drag and drop option - import own 

const DragAndDropPoly = new DragAndDrop({
  source: source,
  formatConstructors: [GeoJSON]
});

map.addInteraction(DragAndDropPoly);

// - adding new modifiable vector

// Pushing the select feature
//var selectInteraction = new Select(); 
//map.addInteraction(selectInteraction);

//function highlightFeature(feat){
//   selectInteraction.getFeatures().push(feat);
//   selectInteraction.dispatchEvent({
//      type: 'select',
//      selected: [feat],
//      deselected: []
//   });
//}




//var pixel = evt.pixel;
//console.log ("pixel:"+pixel);



//cleaning
const clear = document.getElementById('clear');

clear.addEventListener('click', function() {
  if (confirm("Delete feature No "+ ExampleModify.select.getFeatures().getArray()[0].getId()+" ?")) {
      deleted=1;
      console.log ('Deleting-on-click:'+deleted);
      source.removeFeature(ExampleModify.select.getFeatures().getArray()[0]);
      ExampleModify.select.setActive(false);
      ExampleModify.select.setActive(true);
     source.refresh();
   }
});

const trackingb= document.getElementById('trackingb');
trackingb.addEventListener('click', function(evt){if (! document.getElementById('track').checked){ document.getElementById('track').checked=true;
geolocation.setTracking('true')
var coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ?
    new Point(coordinates) : null);
map.getView().animate({center: coordinates, zoom: 19});
document.getElementById("trackingb").style.color="red";}else{document.getElementById('track').checked=false;
geolocation.setTracking('false')
document.getElementById("trackingb").style.color="white"; }
GeoLoclayer.setVisible(document.getElementById("track").checked);
});

const homelocbut = document.getElementById("homeloc");
homelocbut.addEventListener('click', function(evt){
navigator.geolocation.getCurrentPosition(function(pos){
  var coords = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
 map.getView().animate({center: coords, zoom: 12})});
});



const configb=document.getElementById('config');
configb.addEventListener('click', function(evt){
console.log (document.getElementById("layers").style.display);
if (document.getElementById("layers").style.display === "block"){
document.getElementById("config").style.color="white";
document.getElementById("layers").style.display = "none"}else {
document.getElementById("config").style.color="red";
    document.getElementById("layers").style.display = "block";
  }
});

const buttonsave= document.getElementById('buttonsave');
buttonsave.addEventListener('click', function(evt){
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
if (!selected_feature) {console.log ("not selected");
var nogeom = source.getFeatures().length;
var ftrs=source.getFeatures();
console.log (nogeom);
console.log (document.getElementById('FeatID'.value));
var i = 0;
while (i < nogeom){
ftrs=source.getFeatures()[i];
if (ftrs.getId() == document.getElementById('FeatID').value){
console.log (ftrs.getProperties());
selected_feature=source.getFeatures()[i];
};
console.log (ftrs.getId());
i++;};
};
console.log (selected_feature);
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
var Area=Math.trunc(getArea(Targetgeometry));
var length=Math.trunc(getLength(Targetgeometry));
var attribes = { 
"name" : document.getElementById('FeatName').value, 
"Description": document.getElementById('FeatDesc').value, 
"Area": Math.trunc(getArea(Targetgeometry)), 
"FeatureType":FeatProperties.FeatureType,
"Length": Math.trunc(getLength(Targetgeometry)), 
"IDClient": document.getElementById('FeatIDClient').value, 
"Use": document.getElementById('FeatUse').value, 
"Elevation": document.getElementById('FeatSlope').value,
"Cadastre":document.getElementById('FeatCad').value, 
"Other_data": document.getElementById('Otherdata').value, 
"DateCreated": today,
"CreatorID": "TestUser"
};
selected_feature.setProperties(attribes);
       
console.log ("Save clicked"+ ExampleModify.select.getFeatures().getArray()[0].getId
            ());
});

//Downloading all of the features of user layer in GEoJSON format
const format = new GeoJSON({featureProjection: 'EPSG:3857'});
const download = document.getElementById('download');
source.on('change', function() {
  const features = source.getFeatures();
  const json = format.writeFeatures(features);
  download.href = 'data:text/json;charset=utf-8,' + json;
});

//Address search
document.getElementById("buttonsearch").onclick = function addr_search()
{

var inp = document.getElementById("addr");
console.log (inp);

//alert(inp.value);
var url3 ='https://nominatim.openstreetmap.org/search?format=json&limit=5&q=' + inp.value;
console.log (url3);
$.getJSON(url3, function(data) {
 console.log (data);
//alert(inp.value);
var items = [];
var bb = []; 
        $.each(data, function(key, val) {
//items.push("<li><a name=\"reference\" id=\"reference\" href='#' onclick='chooseAddr(" + val.lat + ", " + val.lon + ", \"" + val.type +"\""+ ",\"" + val.osm_type +"\");return false;'>" + val.display_name + '</a></li>');
            bb = val.boundingbox;
//            items.push("<li><a name=\"reference\" id=\"reference\" href='#' //onclick='chooseAddr(" + bb[0] + ", " + bb[2] + ", " + bb[1] + ", " + bb[3]  + ", \"" //+ val.type +"\""+ ",\""+ val.osm_type + "\");return false;'>" + val.display_name + //'</a></li>');
 
var loc1="["+val.lon+","+val.lat+"]";
var loc2=[val.lon,val.lat];
const loc = fromLonLat([val.lon, val.lat]);
    
items.push("<li><a name=\"reference\" id=\"reference\" href='#' > <input id='ss' type='text' value ="+loc2+" hidden=true>"+ val.display_name + '</a></li>');               



 });
console.log (bb);
console.log (items);



//Displaying results of search
$('#results').empty();
    if (items.length != 0) {
      $('<p>', { html: "Search results:" }).appendTo('#results');
      $('<ul/>', {
        'class': 'my-new-list',
        html: items.join('')
      }).appendTo('#results');
    } else {
      $('<p>', { html: "No results found" }).appendTo('#results');
    }
  });
};


document.getElementById("results").onclick=function Loc_zoom(){
//document.getElementById("ss").onclick=function Loc_zoom(){
var location =[]; 
location = JSON.parse("["+document.getElementById("ss").value+"]");
//location = $("#results").val();
console.log ("location: "+ location);
//document.getElementById("results").value = location;
var coords1=location;
var coords3 =document.getElementById("results").value;
console.log ("coords1: "+ coords1[0]);
var coords2 =fromLonLat([coords1[0],coords1[1]]);
console.log ("coords:"+ coords1);
console.log ("coords2:"+ coords2);
//alert (coords1);
map.getView().animate({center: coords2, zoom: 15});
};






var ExampleModify = {
        init: function() {
        this.select= new Select({
        wrapX: false,
        layers: [layer]
        }),             
        map.addInteraction(this.select);
        this.modify= new Modify({
 //           source: source,
            features: this.select.getFeatures()
          });
          map.addInteraction(this.modify);
          this.setEvents();
        },    
        
        setEvents: function() {
          var selectedFeatures = this.select.getFeatures();
            this.select.on('change:active', function() {
            selectedFeatures.forEach(function(each) {
              selectedFeatures.remove(each);
            });
          });
        },
//        select: new Select({
//        wrapX: false,
//        layers: [layer]
//        }),
          setActive: function(active) {
          this.select.setActive(active);
          this.modify.setActive(active);
        }
      };

ExampleModify.init();



//var optionsForm = document.getElementById('options-form');
//var EntryOptions=document.getElementById('options');
//var Draw_type="Polygon";

document.getElementById("Polygon").onclick=function(){
Draw_type="Polygon"};
document.getElementById("LineString").onclick=function(){
Draw_type="LineString"};
document.getElementById("Point").onclick=function(){
Draw_type="Point"};

//console.log ("EntryOptions: "+EntryOptions);
console.log ("Draw_type: "+Draw_type);

 var ExampleDraw = {
        init: function() {
          map.addInteraction(this.Point);
          this.Point.setActive(false);
          map.addInteraction(this.LineString);
          this.LineString.setActive(false);
          map.addInteraction(this.Polygon);
          this.Polygon.setActive(false);
//          map.addInteraction(this.Circle);
//          this.Circle.setActive(false);
        },
        Point: new Draw({
          source: source,
          type: 'Point'
        }),
        LineString: new Draw({
          source: source,
          type: 'LineString'
        }),
        Polygon: new Draw({
          source: source,
          type: 'Polygon'
        }),
//        Circle: new Draw({
//          source: source,
//          type: 'Circle'
//        }),
        getActive: function() {
          return this.activeType ? this[this.activeType].getActive() : false;
        },
        setActive: function(active) {
//          var type = optionsForm.elements['draw-type'].value;
          var type = Draw_type;
          console.log ("Drawtype:"+type);
          if (active) {
            this.activeType && this[this.activeType].setActive(false);
            this[type].setActive(true);
            this.activeType = type;
 console.log ("Active Drawtype:"+type);
          } else {
            this.activeType && this[this.activeType].setActive(false);
            this.activeType = null;
          }
        }
      };
      ExampleDraw.init();

     



document.getElementById("download").onclick=function(){
   //Downloading all of the features of user layer in GEoJSON format
const format = new GeoJSON({featureProjection: 'EPSG:3857'});
//const download = document.getElementById('download');
//source.on('change', function() {
  const features = source.getFeatures();
  const json = format.writeFeatures(features);
  download.href = 'data:text/json;charset=utf-8,' + json;
//});
};



document.getElementById("infooff").onclick=function(){
   if (document.getElementById("3").checked){
   	if (document.getElementById("editw").style.visibility==="visible"){
       		document.getElementById("editw").style.visibility="hidden";
		document.getElementById("infooff").style.color="red"} else {				
		document.getElementById("infooff").style.color="white";
       		document.getElementById("editw").style.visibility="visible"}
	}else{
	document.getElementById("editw").style.visibility="hidden"};
if (document.getElementById("5").checked){
   	if (document.getElementById("editcad").style.visibility==="visible"){
       		document.getElementById("editcad").style.visibility="hidden";
		document.getElementById("infooff").style.color="red"} else {				
		document.getElementById("infooff").style.color="white";
       		document.getElementById("editcad").style.visibility="visible"}
	}else{
	document.getElementById("editcad").style.visibility="hidden"}
};


document.getElementById("search").onclick=function(){
console.log (document.getElementById("search_container").style.display);
if (document.getElementById("search_container").style.display === "block"){
document.getElementById("search").style.color="white";
document.getElementById("search_container").style.display = "none"}else {
document.getElementById("search").style.color="red";
    document.getElementById("search_container").style.display = "block";
  }
};



document.getElementById("Polygon").onclick=function(){
Draw_type="Polygon";
ExampleDraw.getActive() && ExampleDraw.setActive(true);};
document.getElementById("LineString").onclick=function(){
Draw_type="LineString";
ExampleDraw.getActive() && ExampleDraw.setActive(true);};
document.getElementById("Point").onclick=function(){
Draw_type="Point";
ExampleDraw.getActive() && ExampleDraw.setActive(true);};

    
          
      document.getElementById("edit").onclick= function()
          {
if (document.getElementById("edit").style.color == "white"){
document.getElementById("create").style.color="white";
document.getElementById("edit").style.color="red";
document.getElementById("draw-type").style.display = "none";
document.getElementById("clear").hidden=false;
//highlightFeature(source.getFeatureById(1));
OptionsMode="Edit";
            Textmessage = 'Click to Modify';
            ExampleModify.select.setActive(false);
            ExampleDraw.setActive(false);
            ExampleModify.setActive(true);  
            document.getElementById("buttonsave").style.visibility="visible";    
            console.log ("Modifyig mode");}else{
document.getElementById("create").style.color="white";
document.getElementById("edit").style.color="white";
document.getElementById("draw-type").style.display = "none";
document.getElementById("clear").hidden=true;
ExampleDraw.setActive(false);
            ExampleModify.setActive(false);
            ExampleModify.select.setActive(true);
            document.getElementById("buttonsave").style.visibility="hidden";
            console.log ("Select"); 
}
          }; 
 
          document.getElementById("create").onclick= function()
          {
if (document.getElementById("create").style.color == "white"){ 
//if (saved== 0){console.log('not saved')};
       saved = 1;
document.getElementById("edit").style.color="white";
document.getElementById("create").style.color="red";
OptionsMode="Draw";
document.getElementById("draw-type").style.display = "block";
document.getElementById("clear").hidden=true;
	    Textmessage = 'Click to Draw';
            ExampleDraw.setActive(true);
            ExampleModify.setActive(false);
            document.getElementById("buttonsave").style.visibility="visible";
            console.log ("Drawing mode");
          }else{
document.getElementById("edit").style.color="white";
document.getElementById("create").style.color="white";
OptionsMode="Select";
document.getElementById("draw-type").style.display = "none";
document.getElementById("clear").hidden=true;
	    Textmessage = 'Click to Select';
            ExampleDraw.setActive(false);
            ExampleModify.setActive(false);
            ExampleModify.select.setActive(true);
            document.getElementById("buttonsave").style.visibility="hidden";
            console.log ("Select"); 
       }};
     

var backup_feature=[];
var modified_feature=[];

ExampleModify.select.on('select', function() { 
//ExampleModify.select.getFeatures().on('add', function(evt){
//ExampleModify.modify.on('modifystart', function(evt){
console.log ('New feature selected');
saved = 1;//remove when database
//activate when database
if (saved==0){
console.log ('Selected, previous not saved');
if (OptionsMode=="Edit"){
console.log ('Modifying'+modifying);
if (modifying==1){ 
if (confirm("Save?")) {
    saved=1;
    modifying=0;
  } else {
    saved=1;
    modifying=0;
//var i = 0;
//console.log(backup_feature.length);
//for (i = 0; i < modified_feature.flatCoordinates.length; i++) {
//modified_feature.flatCoordinates[i]=null;
//};
//for (i = 0; i < backup_feature.length; i++) {
//modified_feature.flatCoordinates[i]=backup_feature[i];
//};

//    console.log(modified_feature);
//    source.refresh();
  }};
//activate when database
}};
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
var i=0;

//var Area1=getArea(geometry1);
//var Length1=getLength(geometry1);
var Area=Math.trunc(getArea(Targetgeometry));
var length=Math.trunc(getLength(Targetgeometry));

document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=Math.trunc(getArea(Targetgeometry));;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=Math.trunc(getLength(Targetgeometry));;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;

//Textmessage = 'Modify or Save when finished';
if (OptionsMode=="Browsemode"){
//;(document.getElementById('options0').checked){
Textmessage = 'Click to get Info';
source.refresh();
};

if (OptionsMode=="Edit"){
//(document.getElementById('options2').checked){
console.log ('Modifying'+modifying);

console.log ('Saved:'+saved);
Textmessage = 'Modify or Save when finished';
source.refresh();
};
source.refresh();

});




ExampleModify.modify.on('modifyend', function(evt){
console.log ('Modifyend');
helpTooltip.setPosition(evt.coordinate);
var selected_feature=ExampleModify.select.getFeatures().getArray()[0];
var Targetgeometry=selected_feature.getGeometry();
var FeatProperties=selected_feature.getProperties();
var FeatID=selected_feature.getId();
//var Area1=getArea(geometry1);
//var Length=getLength(geometry1);
var Area=Math.trunc(getArea(Targetgeometry));
var length=Math.trunc(getLength(Targetgeometry));
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=Area;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
modified_feature=Targetgeometry;
console.log ('backup_feature while modifying');
console.log (backup_feature);
modifying=1;
saved=0;
});



ExampleDraw.Polygon.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started");
console.log (source.getFeatures());
console.log ("poygon-on:"+OptionsMode);
         
          });

ExampleDraw.Point.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started-point");
         
          });
ExampleDraw.LineString.on('drawstart',
//ExampleDraw.on('drawstart',
          function(evt) {
            var geom = evt.feature;
            /** @type {module:ol/coordinate~Coordinate|undefined} */
            var tooltipCoord = evt.coordinate;
drawing_started =1;
console.log ("drawing_started-point");
         
          });

layer.onchange=function(){
console.log ("source changed");
console.log (source.getFeatures());
};

ExampleDraw.Polygon.on('drawend', function (evt){
//ExampleDraw.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend: start-drawend");
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
console.log ("draw-end options mode:"+OptionsMode);
console.log ("draw-end-getactive type: Polygon:"+ExampleDraw.getActive("Polygon"));
var nogeom = source.getFeatures();
var j1=0;
var maxIndex1 = 0;
source.forEachFeature(function(feature) {
  // you may want to set the index depending on other attributes first:
  // feature.setId(feature.get('yourPreferedKeyForIndex'));      
  // get feature index
  var featureIndex = feature.getId().valueOf()*1;
  if (featureIndex > maxIndex1) {
  maxIndex1 = featureIndex};
j1= j1 +1;
  console.log("FIndex:"+j1+" "+featureIndex+" "+maxIndex1);
});

//var hexString = (nogeom.length).toString(16);
var newIndex = maxIndex1.valueOf()*1 + 1;
//var hexString = (newIndex).toString(16);
var hexString = newIndex.toString();	
//var hexString= maxIndex1 + 1;
console.log ("Length: "+nogeom.length);
geom.setId(hexString);
var featureCount = layer.getSource().getFeatures().length;
console.log ("number fo features- long:"+featureCount);
console.log (source.getFeatures());
console.log ("get ID number: "+geom.getId());
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"Polygon","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
var lastgeom=source.getFeatures();

var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatUse').value=FeatProperties.Use;
document.getElementById('FeatDesc').value=FeatProperties.Description;
document.getElementById('FeatCad').value=FeatProperties.Cadastre;
document.getElementById('FeatSlope').value=FeatProperties.Elevation;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value=FeatProperties.Area;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=FeatProperties.Length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties().DateCreated);
console.log ('end draw-poly');});

ExampleDraw.Point.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
var nogeom = source.getFeatures();
console.log (source.getFeatures());
//var hexString = nogeom.length.toString(16);
var j1=0;
var maxIndex1 = 0;
source.forEachFeature(function(feature) {
  // you may want to set the index depending on other attributes first:
  // feature.setId(feature.get('yourPreferedKeyForIndex'));      
  // get feature index
  var featureIndex = feature.getId().valueOf()*1;
  if (featureIndex > maxIndex1) {
  maxIndex1 = featureIndex};
j1= j1 +1;
  console.log("FIndex:"+j1+" "+featureIndex+" "+maxIndex1);
});

//var hexString = (nogeom.length).toString(16);
var newIndex = maxIndex1.valueOf()*1 + 1;
//var hexString = (newIndex).toString(16);
var hexString = (newIndex).toString();
geom.setId(hexString);
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"Point","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
var FeatType=geom.getId();
var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value="N/A";
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value="N/A";
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties().DateCreated);
console.log (geom.getGeometry());
console.log ('end draw - point');});


ExampleDraw.LineString.on('drawend', function (evt){
Textmessage = 'Finished, Click to Draw or select other option';
helpTooltipElement.innerHTML = 'Finished, Click to Draw or select other option';drawing_started =0;
var geom = evt.feature;
console.log ("evtfeatureend:"+evt.feature);
console.log ("geometry:"+geom.getGeometry());
var nogeom = source.getFeatures();
var j1=0;
var maxIndex1 = 0;
source.forEachFeature(function(feature) {
  // you may want to set the index depending on other attributes first:
  // feature.setId(feature.get('yourPreferedKeyForIndex'));      
  // get feature index
  var featureIndex = feature.getId().valueOf()*1;
  if (featureIndex > maxIndex1) {
  maxIndex1 = featureIndex};
j1= j1 +1;
  console.log("FIndex:"+j1+" "+featureIndex+" "+maxIndex1);
});

//var hexString = (nogeom.length).toString(16);
var newIndex = maxIndex1.valueOf()*1 + 1;
//var hexString = (newIndex).toString(16);
var hexString = (newIndex).toString();
geom.setId(hexString);
var Targetgeometry=geom.getGeometry();
output=Math.trunc(getArea(Targetgeometry));
length=Math.trunc(getLength(Targetgeometry));
console.log (output,length);
console.log (Targetgeometry);
var attribes = { "name" : "Myname"+nogeom.length, "Description": "", "Area": output, "FeatureType":"LineString","Length":length, "IDClient": " ", "Use": " ", "Elevation": " ","Cadastre":" ", "Other_data": "Enter other data", "DateCreated": today,"CreatorID": "TestUser"};
geom.setProperties(attribes);
var FeatID=geom.getId(); 
var FeatType=geom.getId();
var FeatProperties=geom.getProperties();
document.getElementById('FeatID').value = FeatID;
document.getElementById('FeatName').value=FeatProperties.name;
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatType').value=FeatProperties.FeatureType;
document.getElementById('FeatArea').value="N/A";
document.getElementById('FeatIDClient').value=FeatProperties.IDClient;
document.getElementById('FeatIDCreated').value=FeatProperties.CreatorID;
document.getElementById('FeatLength').value=FeatProperties.Length;
document.getElementById('FeatX').value=Targetgeometry.flatCoordinates[0];
document.getElementById('FeatY').value=Targetgeometry.flatCoordinates[1];
document.getElementById('FeatDate').value=FeatProperties.DateCreated;
document.getElementById('Otherdata').value=FeatProperties.Other_data;
console.log ("Properties Draw: "+geom.getProperties());
console.log ('end draw-linestring');});


const PolySnap=new Snap({
   source: layer.getSource(),
pixelTolerance: 10
});

//Adding snapping
map.addInteraction(PolySnap);




// set layer visibility


document.getElementById("0").onclick=function(){googlestreet.setVisible(document.getElementById("0").checked)};
document.getElementById("1").onclick=function(){osmlayer.setVisible(document.getElementById("1").checked)};
document.getElementById("2").onclick=function(){countries.setVisible(document.getElementById("2").checked);
const initial_country_value=document.getElementById("2").checked};
document.getElementById("5").onclick=function(){ALBcadlayer.setVisible(document.getElementById("5").checked);if (document.getElementById("5").checked){
document.getElementById("editcad").style.visibility="visible";}else {document.getElementById("editcad").style.visibility="hidden";}};
document.getElementById("6").onclick=function(){ALBCIRlayer.setVisible(document.getElementById("6").checked)};
document.getElementById("4").onclick=function(){googlemaps.setVisible(document.getElementById("4").checked)};
document.getElementById("8").onclick=function(){ALBlayer.setVisible(document.getElementById("8").checked)};
document.getElementById("7").onclick=function(){ALBDEMlayer.setVisible(document.getElementById("7").checked)};
document.getElementById("3").onclick=function(){layer.setVisible(document.getElementById("3").checked);if (document.getElementById("3").checked){
document.getElementById("editw").style.visibility="visible";}else {document.getElementById("editw").style.visibility="hidden";}};

document.getElementById("trackinfo").onclick=function(){
if (document.getElementById("trackinfo").checked){
document.getElementById("edittrack").style.visibility="visible"}else {document.getElementById("edittrack").style.visibility="hidden"}};

document.getElementById("FeatNameY").onclick=function(){
document.getElementById("FeatName").hidden=( ! document.getElementById("FeatNameY").checked);
document.getElementById("FeatNameL").hidden=( ! document.getElementById("FeatNameY").checked)};

document.getElementById("FeatDescY").onclick=function(){
document.getElementById("FeatDesc").hidden=( ! document.getElementById("FeatDescY").checked);
document.getElementById("FeatDescL").hidden=( ! document.getElementById("FeatDescY").checked)};

document.getElementById("FeatUseY").onclick=function(){
document.getElementById("FeatUse").hidden=( ! document.getElementById("FeatUseY").checked);
document.getElementById("FeatUseL").hidden=( ! document.getElementById("FeatUseY").checked)};

document.getElementById("FeatCadY").onclick=function(){
document.getElementById("FeatCad").hidden=( ! document.getElementById("FeatCadY").checked);
document.getElementById("FeatCadL").hidden=( ! document.getElementById("FeatCadY").checked)};

document.getElementById("FeatDateY").onclick=function(){
document.getElementById("FeatDate").hidden=( ! document.getElementById("FeatDateY").checked);
document.getElementById("FeatDateL").hidden=( ! document.getElementById("FeatDateY").checked)};

document.getElementById("OtherdataY").onclick=function(){
document.getElementById("Otherdata").hidden=( ! document.getElementById("OtherdataY").checked);
document.getElementById("OtherdataL").hidden=( ! document.getElementById("OtherdataY").checked)};


document.getElementById("FeatIDClientY").onclick=function(){
document.getElementById("FeatIDClient").hidden=( ! document.getElementById("FeatIDClientY").checked);
document.getElementById("FeatIDClientL").hidden=( ! document.getElementById("FeatIDClientY").checked)};

document.getElementById("FeatSlopeY").onclick=function(){
document.getElementById("FeatSlope").hidden=( ! document.getElementById("FeatSlopeY").checked);
document.getElementById("FeatSlopeL").hidden=( ! document.getElementById("FeatSlopeY").checked)};

document.getElementById("FeatIDCreatedY").onclick=function(){
document.getElementById("FeatIDCreated").hidden=( ! document.getElementById("FeatIDCreatedY").checked);
document.getElementById("FeatIDCreatedL").hidden=( ! document.getElementById("FeatIDCreatedY").checked)};

document.getElementById("trackinfo").onclick=function(){
document.getElementById("edittrack").hidden=( ! document.getElementById("trackinfo").checked);
};

//Geolocation


function el(id) {
  return document.getElementById(id);
}

document.getElementById("track").onclick= function() {
console.log (document.getElementById("track").value);
GeoLoclayer.setVisible(document.getElementById("track").checked);
if (document.getElementById("track").checked){
  geolocation.setTracking('true')
var coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ?
    new Point(coordinates) : null);
map.getView().animate({center: coordinates, zoom: 19});

} else {
geolocation.setTracking('false')
//document.getElementById("track").value='off'
}
};

// update the HTML page when the position changes.
geolocation.on('change', function() {
  el('accuracy').innerText = geolocation.getAccuracy() + ' [m]';
  el('altitude').innerText = geolocation.getAltitude() + ' [m]';
  el('altitudeAccuracy').innerText = geolocation.getAltitudeAccuracy() + ' [m]';
  el('heading').innerText = geolocation.getHeading() + ' [rad]';
  el('speed').innerText = geolocation.getSpeed() + ' [m/s]';
});

// handle geolocation error.
geolocation.on('error', function(error) {
  var info = document.getElementById('info');
  info.innerHTML = error.message;
  info.style.display = '';
});


geolocation.on('change:position', function() {
  var coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ?
    new Point(coordinates) : null);
//map.getView().animate({center: coordinates, zoom: 19});
});

const GeoLocSource= new VectorSource({
    features: [accuracyFeature, positionFeature]
  });
const GeoLoclayer = new VectorLayer({
  source: GeoLocSource
});
map.addLayer(GeoLoclayer);
//geolocation - end

//https://jqueryui.com/draggable/
